import { Translation } from 'cng-common/features/translations/components/translation'

import { getQuarterStateTranslationKey } from '../../../../helpers/getQuarterStateTranslationKey'

import styles from './getCurrentYearQuarterThShortView.module.scss'

export const getCurrentYearQuarterThShortView = (
  quarter: 1 | 2 | 3 | 4,
  currentQuarter: number,
  currentYear: number,
  shortView: boolean
) => {
  return (
    <div>
      <div className={styles.shortView}>
        Q{quarter}
        <Translation
          text={getQuarterStateTranslationKey({
            quarter,
            currentQuarter,
            shortView,
            currentYear,
            year: currentYear,
          })}
        />
      </div>
    </div>
  )
}
